/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Event_Group_Order_By_IdInputs */

const en_merge_event_group_order_by_id = /** @type {(inputs: Merge_Event_Group_Order_By_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Id`)
};

const fr_merge_event_group_order_by_id = /** @type {(inputs: Merge_Event_Group_Order_By_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const de_merge_event_group_order_by_id = /** @type {(inputs: Merge_Event_Group_Order_By_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausweis`)
};

const it_merge_event_group_order_by_id = /** @type {(inputs: Merge_Event_Group_Order_By_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Id`)
};

const ru_merge_event_group_order_by_id = /** @type {(inputs: Merge_Event_Group_Order_By_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Идентификатор`)
};

const es_merge_event_group_order_by_id = /** @type {(inputs: Merge_Event_Group_Order_By_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identificación`)
};

const zh_cn2_merge_event_group_order_by_id = /** @type {(inputs: Merge_Event_Group_Order_By_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const ja_merge_event_group_order_by_id = /** @type {(inputs: Merge_Event_Group_Order_By_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const hi_merge_event_group_order_by_id = /** @type {(inputs: Merge_Event_Group_Order_By_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पहचान`)
};

const pt_pt2_merge_event_group_order_by_id = /** @type {(inputs: Merge_Event_Group_Order_By_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eu ia`)
};

/**
* | output |
* | --- |
* | "Id" |
*
* @param {Merge_Event_Group_Order_By_IdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_event_group_order_by_id = /** @type {((inputs?: Merge_Event_Group_Order_By_IdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Event_Group_Order_By_IdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_merge_event_group_order_by_id(inputs)
	if (locale === "de") return de_merge_event_group_order_by_id(inputs)
	if (locale === "it") return it_merge_event_group_order_by_id(inputs)
	if (locale === "ru") return ru_merge_event_group_order_by_id(inputs)
	if (locale === "es") return es_merge_event_group_order_by_id(inputs)
	if (locale === "zh-CN") return zh_cn2_merge_event_group_order_by_id(inputs)
	if (locale === "ja") return ja_merge_event_group_order_by_id(inputs)
	if (locale === "hi") return hi_merge_event_group_order_by_id(inputs)
	if (locale === "pt-PT") return pt_pt2_merge_event_group_order_by_id(inputs)
	return en_merge_event_group_order_by_id(inputs)
});